import { render, staticRenderFns } from "./TableRoundTime.vue?vue&type=template&id=245bc452&scoped=true&"
import script from "./TableRoundTime.vue?vue&type=script&lang=js&"
export * from "./TableRoundTime.vue?vue&type=script&lang=js&"
import style0 from "./TableRoundTime.vue?vue&type=style&index=0&id=245bc452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245bc452",
  null
  
)

export default component.exports